import axios from 'axios';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { ContinueButton } from '../ContinueButton';
import { PortCollectionSelector } from './PortSelector';
import { VolumeSlider } from './VolumeSlider';

interface OtherDetailFormValues {
  volume: number;
  portCollections: string[];
}

interface Props {
  submit: (values: OtherDetailFormValues) => Promise<void>;
}

export const Other: React.FC<Props> = (props) => {
  const { register, setValue, watch, formState, handleSubmit } = useForm<OtherDetailFormValues>({
    defaultValues: { portCollections: [], volume: 3000 },
  });

  const [error, setError] = React.useState('');

  register('portCollections', { required: true });
  register('volume', { required: true });

  const portCollections = watch('portCollections');
  const volume = watch('volume');

  const onSubmit = handleSubmit(async (values) => {
    try {
      await props.submit(values);
    } catch (err) {
      if (axios.isAxiosError(err)) {
        setError(err.response?.data.message || err.message);
      } else {
        setError('A problem ocurred while creating the company.');
      }
      // eslint-disable-next-line
      console.error(err);
    }
  });

  return (
    <form className="space-y-8" onSubmit={onSubmit}>
      <VolumeSlider
        onChange={(value) =>
          setValue('volume', value, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          })
        }
        value={volume}
      />
      <PortCollectionSelector
        onChange={(value) =>
          setValue('portCollections', value, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          })
        }
        value={portCollections}
      />
      <ContinueButton
        disabled={!formState.isValid}
        loading={formState.isSubmitting}
        error={error}
      />
    </form>
  );
};
Other.displayName = 'CreateCompany.CompanyDetails.Other';
